import { TIMESLOT_EPOCH_UNIX, type TokenDecoded } from '@pink/shared';

import { CANCEL_CUTOFF_MS, TIMESLOT_TO_MS_FACTOR } from './token.constants.js';

/**
 * Prüft die Selbst-Absage-Sperrfrist (AFO-008).
 *
 * `true` → Restzeit bis zum Termin ist mindestens `CANCEL_CUTOFF_MS`, Absage
 * online möglich. `false` → Termin liegt innerhalb der Sperrfrist (oder bereits
 * in der Vergangenheit), Patient:in muss telefonisch klären.
 *
 * Die Grenze ist **inklusiv erlaubend**: liegt der Termin exakt
 * `CANCEL_CUTOFF_MS` entfernt, ist die Absage noch möglich; jede
 * Millisekunde näher wird abgewiesen.
 *
 * @param decoded Ergebnis von `decodeToken`.
 * @param now     Referenz-Zeitpunkt in Millisekunden (UTC). Test-Hook;
 *                Produktion ruft mit `Date.now()` auf.
 */
export function isWithinCancelCutoff(decoded: TokenDecoded, now: number): boolean {
  const appointmentMs =
    (TIMESLOT_EPOCH_UNIX + decoded.timeSlotSecondsFromEpoch) * TIMESLOT_TO_MS_FACTOR;
  return appointmentMs - now >= CANCEL_CUTOFF_MS;
}
